var _g, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.21 99.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.61,79.76c-17.6,0-31.93-14.32-31.93-31.93,0-17.6,14.32-31.93,31.93-31.93s31.93,14.32,31.93,31.93-14.32,31.93-31.93,31.93ZM50.61,17.81c-16.56,0-30.02,13.47-30.02,30.02,0,16.56,13.47,30.03,30.02,30.03s30.02-13.47,30.02-30.03-13.47-30.02-30.02-30.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.61,88.54c-22.45,0-40.71-18.26-40.71-40.71,0-10.87,4.23-21.1,11.92-28.79,7.69-7.69,17.91-11.92,28.78-11.92h0c22.45,0,40.71,18.26,40.71,40.71s-18.26,40.71-40.71,40.71ZM50.61,9.03c-10.37,0-20.11,4.04-27.44,11.37-7.33,7.33-11.37,17.07-11.37,27.44,0,21.4,17.41,38.81,38.81,38.81,21.4,0,38.81-17.41,38.81-38.81S72.01,9.03,50.61,9.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.61,69.99c-12.22,0-22.16-9.94-22.16-22.16s9.94-22.16,22.16-22.16,22.16,9.94,22.16,22.16h0c0,12.22-9.94,22.16-22.16,22.16ZM50.61,27.57c-11.17,0-20.26,9.09-20.26,20.26s9.09,20.26,20.26,20.26,20.26-9.09,20.26-20.26c0-11.17-9.09-20.26-20.26-20.26Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.58,48.78H5.56c-.53,0-.95-.43-.95-.95s.43-.95.95-.95h39.02c.53,0,.95.43.95.95s-.43.95-.95.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.67,48.78h-39.02c-.53,0-.95-.43-.95-.95s.43-.95.95-.95h39.02c.53,0,.95.43.95.95s-.43.95-.95.95Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.61,42.75c-.53,0-.95-.43-.95-.95V2.78c0-.53.43-.95.95-.95s.95.43.95.95v39.02c0,.53-.43.95-.95.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.61,93.84c-.53,0-.95-.43-.95-.95v-39.02c0-.53.43-.95.95-.95s.95.43.95.95v39.02c0,.53-.43.95-.95.95Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 50.62,
    cy: 47.83,
    r: 1.51
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.51,28.58c-.53,0-.95-.43-.95-.95V8.46c0-3.2-2.6-5.8-5.8-5.8h-19.17c-.53,0-.95-.43-.95-.95s.43-.95.95-.95h19.17c4.25,0,7.71,3.46,7.71,7.71v19.17c0,.53-.43.95-.95.95Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.71,28.48c-.53,0-.95-.43-.95-.95V8.46C.76,4.21,4.21.76,8.46.76h19.17c.53,0,.95.43.95.95s-.43.95-.95.95H8.46c-3.2,0-5.8,2.6-5.8,5.8v19.06c0,.53-.43.95-.95.95Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.63,98.46H8.46c-4.25,0-7.71-3.46-7.71-7.71v-19.06c0-.53.43-.95.95-.95s.95.43.95.95v19.06c0,3.2,2.6,5.8,5.8,5.8h19.17c.53,0,.95.43.95.95s-.43.95-.95.95Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.75,98.46h-18.48c-.53,0-.95-.43-.95-.95s.43-.95.95-.95h18.48c3.2,0,5.8-2.6,5.8-5.8v-18.96c0-.53.43-.95.95-.95s.95.43.95.95v18.96c0,4.25-3.46,7.71-7.71,7.71Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/Target.c14e79f7e38f17343608e4cebd941a88.svg";
export { ForwardRef as ReactComponent };